import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { IPanDetails, IReSendEmailOTP, ISendEmail } from "../shared/dtos";
import otpIcon from "../Components/assets/Images/otpIcon.svg";
import {
  CompleteAadhaarAPICall,
  digiLockerInitAPICall,
  panDetailsAPICall,
  reSendEmailOTPAPICall,
  sendEmialAPICall,
  stageDetailsAPICall,
  startOverAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import PanStyles from "../pages/Styles/PanVerification.module.scss";
import calenderImage from "../Components/assets/Images/calendar.svg";
import SnackBar from "../Components/SnackBars/SnackBar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import keyboardicon from "../Components/assets/Images/stepkeyboard.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { confirmAlert } from "react-confirm-alert";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";
import ContinueWithGoogle from "../Components/ContinueWithGoogle/ContinueWithGoogle";
import ContinueWithGoogleNew from "../Components/ContinueWithGoogle/ContinueWithGoogleNew";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import { isMobile } from "react-device-detect";
import KRAScreen from "./KRAscreen";

const schema = Yup.object().shape({
  fullName: Yup.string()
    .required("Name is Required")
    .min(3, "Minmum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    // .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .max(50)
    .transform((value: any) => value && value.toUpperCase()),
  pannumber: Yup.string()
    .required("Pan Number is Required")
    .max(10)
    .matches(
      /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
      "Enter Valid Pan Number",
    )
    .transform((value: any) => value && value.toUpperCase()),
  emailotp: Yup.string().required("Email Otp is Required").max(6).min(6),
  // dateofBirth: Yup.string().required("Date of Birth is a required field"),
  email: Yup.string()
    .required("Email is Required")
    .max(50, "Max 50 characters is allowed")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Enter Valid Email"),
});

function DateIcon(props) {
  return (
    <img src={calenderImage} style={{ width: "25px", paddingRight: "8px" }} />
  );
}

const dots = ["1", "2", "3", "4", "5", "6"];

export default function PanVerificationPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dobError, setDobError] = useState("");
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState<any>("");
  const [panPrefill, setPanPrefill] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [emailotp, setEmailotp] = useState("");
  const [emailtyped, setEmailtyped] = useState("");
  const [emailGoogle, setEmailGoogle] = useState("");
  const [dobPrefill, setPanDobfill] = useState<any>("");
  const [prefilloading, setprefilloading] = useState(true);
  const [rejectMessage, setRejectMessage] = useState("");
  const [disablePan, setDisablePan] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [backdropLoading, setbackdropLoading] = useState(false);
  const [getloading, setGetloading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigationData = routesData;
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState<any>(30);
  const [timerId, setTimerId] = useState<any>(null);
  const [otpSent, setOtpSent] = useState(false);
  const [isGoogleVerified, setIsGoogleVerified] = useState(false);
  const [kraFetched, setKraFetched] = useState(false);
  const [KraData, setKraData] = useState<any>();

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let obj: any = {
      stage: "pan",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        setprefilloading(false);
        const responseData = response.data;
        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));

        setRejectMessage(response?.data?.data?.ErrorMessage);
        setPanPrefill(response?.data?.data?.data?.pan_no);
        if (response?.data?.data?.data?.dob) {
          setPanDobfill(dayjs(response?.data?.data?.data?.dob));
        }
        if (response?.data?.data?.data?.pan_no) {
          setDisablePan(true);
        }
        if (response?.data?.data?.data?.pan_name) {
          setFullName(response?.data?.data?.data?.pan_name);
        }
        if (response?.data?.data?.data?.email) {
          setEmail(response?.data?.data?.data?.email);
        }
        if (response?.data?.data?.data?.is_google_verified) {
          setIsGoogleVerified(response?.data?.data?.data?.is_google_verified);
          setEmailotp("123456");
        }
      })
      .catch((error: any) => {
        setprefilloading(false);
      });
  }, []);

  useEffect(() => {
    // setIsButtonDisabled(true);
    // setCountdown(30);
    // if (timerId === null) {
    //   let interval = setInterval(() => {
    //     setCountdown((prevCountdown) => prevCountdown - 1);
    //   }, 1000);
    //   setTimerId(interval);
    // }
  }, []);
  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  function panDetails(values: any, name: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitPan",
      },
    });

    setloading(true);
    let obj: any = {
      pan_no: values?.pannumber?.toUpperCase(),
      // dob: date,
      email: values?.email,
      email_otp: isGoogleVerified ? "" : values.emailotp,
      email_authorize: isGoogleVerified,
    };
    console.log("obj", obj);
    panDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response?.data;

        // console.log("responseData", responseData);

        if (!responseData) {
          setMessage("Failed to get Data");
          setTimeout(() => {
            setMessage("");
          }, 5000);
        }
        setloading(false);

        if (responseData.data?.next_stage === "kra_or_aadhaar") {
          if (responseData.data.is_kra_fetched) {
            setKraData(responseData.data.kra);
            setKraFetched(true);
          } else {
            handleDigilocker();
          }
        } else {
          if (
            responseData?.data?.next_stage &&
            navigationData.hasOwnProperty(responseData?.data?.next_stage)
          ) {
            navigate(navigationData[responseData?.data?.next_stage]);
          }
        }
      })
      .catch((error: any) => {
        //console.log("error", error);
        setloading(false);

        setMessage(
          error?.message.includes("Network")
            ? "Error Occured, Please try again"
            : error?.response?.data?.message,
        );

        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const handleDigilocker = () => {
    setloading(true);
    let digilink: string = "";

    let obj: any = {
      digi_redirect_type: "ekyc_aadhaar",
    };
    digiLockerInitAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // setloading(false);
        // console.log("responseData", responseData);
        digilink = responseData.data.link;

        window.location.href = digilink;
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const CompleteAadhaarStage = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitAadhaar",
      },
    });

    CompleteAadhaarAPICall()
      .then((response: any) => {
        // console.log("response", response.data.data.next_stage);
        if (
          response.data.data.next_stage &&
          navigationData.hasOwnProperty(response.data.data.next_stage)
        ) {
          navigate(navigationData[response.data.data.next_stage]);
        }
      })
      .catch((error: any) => {});
  };

  const handleClick = (values: any, name: any) => {
    panDetails(values, name);
    // const dobLimit = new Date();
    // dobLimit.setFullYear(dobLimit.getFullYear() - 18);
    // if (!dob || dob > dobLimit) {
    //   // setDobError(true);

    //   setDobError("Your Age is Below 18");
    //   setTimeout(() => {
    //     setDobError("");
    //   }, 3000);
    //   // alert("Your Age is Below 18");
    // } else {
    //   panDetails(formatedDate, values, name);
    // }
  };

  const eighteenYearsAgo = dayjs().subtract(18, "year");
  const maxDate = dayjs("1915-01-01");

  const renderYear = (year) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {year - maxDate.year()}
      </div>
    );
  };

  function sendEmailAddress(emailid: any, name: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitEmail",
        name: name,
        email: emailid,
      },
    });
    let obj: ISendEmail = {
      email: emailid,
    };
    setGetloading(true);
    sendEmialAPICall(obj)
      .then((response: any) => {
        setEmailtyped(emailid);
        sessionStorage.setItem("client-email", emailid);
        const responseData = response.data;
        // console.log(response, "response");
        setGetloading(false);
        setOtpSent(true);
        setSuccessMessage("Successfully sent the OTP to your Email Id.");
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);
        setIsButtonDisabled(true);
        setCountdown(30);

        if (timerId === null) {
          let interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTimerId(interval);
        }
      })
      .catch((error: any) => {
        setGetloading(false);
        // console.log("error", error);
        setOtpSent(false);
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const handleResendOTP = (values: any) => {
    setloading(true);
    reSendemailOTP(values);
  };

  function reSendemailOTP(values: any) {
    let obj: IReSendEmailOTP = {
      validation_id: "",
      email: values?.email,
    };
    reSendEmailOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data.data;
        setloading(false);
        setOpen(true);
        setSuccessMessage("Successfully sent the OTP to your Email Id.");
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);
        setOtpSent(true);
        setTimeout(() => {
          setOpen(false);
        }, 3000);
        setIsButtonDisabled(true);
        setCountdown(30);
      })
      .catch((error: any) => {
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }
  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;

                setBackDrop(false);
                navigate("/");
              })
              .catch((error: any) => {
                setBackDrop(false);
              });
          },
        },
      ],
    });
  };

  const callBackMessage = (data: any) => {
    setMessage(data);
  };

  const handleChangeField = (
    name: any,
    value: any,
    setFieldValue: any,
    values: any,
  ) => {
    setFieldValue(name, value);
    //console.log( value);
    if (value.length === 6) {
      // emailOTPValidation(value);
    }
  };

  const handleCallBackSuccess = (googleData: any) => {
    console.log("googleData", googleData);
    setEmailGoogle(googleData?.email || "");
    setIsGoogleVerified(true);
  };

  // console.log("email ", email);

  return (
    <>
      <SucessSnackBar message={successMessage} />
      {/* <div className={PanStyles.step}>
        <img src={keyboardicon} /> Step 1 of 4
      </div> */}
      <ProgressComp />
      <div>{backdrop && <StartOverBackDrop />}</div>
      <>
        <div className={PanStyles.mainWrapper}>
          {!kraFetched ? (
            <>
              {prefilloading && (
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={open}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              )}
              <div className={PanStyles.wrapper}>
                {/* <div className={PanStyles.step}>
            <img src={keyboardicon} /> Step 1 of 10
          </div> */}
                <div className={PanStyles.RightContainer}>
                  {!prefilloading ? (
                    <>
                      <div className={PanStyles.headerSection}>
                        <p className={PanStyles.signup}>
                          {/* {panPrefill === "" ? "" : "Fetched"} */}
                          Verify Your Details
                        </p>
                        <p className={PanStyles.subText}>
                          {/* Your PAN is needed to verify your identity */}
                          {panPrefill === ""
                            ? "Your PAN is needed to verify your identity"
                            : "Review your Name and PAN details. Update if incorrect or enter them if not auto-filled."}
                        </p>
                      </div>

                      <Formik
                        validationSchema={schema}
                        initialValues={{
                          fullName: fullName === "" ? "" : fullName,
                          pannumber: panPrefill === "" ? "" : panPrefill,
                          // dateofBirth: dobPrefill === "" ? null : dobPrefill,
                          email: email ? email : "",
                          emailotp: emailotp ? emailotp : "",
                        }}
                        onSubmit={(values: any) => {
                          console.log("clcilc");
                          // const date = new Date(values.dateofBirth.$d);
                          // const formattedDate = date.toLocaleDateString(
                          //   "en-GB",
                          //   {
                          //     year: "numeric",
                          //     day: "2-digit",
                          //     month: "2-digit",
                          //   },
                          // );
                          // const [month, day, year] = formattedDate.split("/");
                          // const formatDate = `${year}/${day}/${month}`;
                          const formatDate = "";

                          handleClick(values, fullName);
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          setFieldValue,
                        }) => {
                          console.log("errors", errors);
                          console.log("values", values);
                          return (
                            <>
                              <form
                                noValidate
                                onSubmit={handleSubmit}
                                onKeyDown={(event) => {
                                  event.code === "Enter" ||
                                    (event.code === "NumpadEnter" &&
                                      handleSubmit());
                                  // event.code.includes("Enter") && handleSubmit()
                                }}
                                // style={{ width: "100%" }}
                              >
                                <div className={PanStyles.textfeildSection}>
                                  <div>
                                    <div className={PanStyles.labeltext}>
                                      Full Name{" "}
                                    </div>
                                    <TextField
                                      autoComplete="off"
                                      sx={{
                                        fieldset: {
                                          borderColor: "#E5E7EB",
                                          borderRadius: "100px",
                                        },
                                      }}
                                      className={PanStyles.textfeild}
                                      id="outlined-basic"
                                      // label="PAN"
                                      name="fullName"
                                      placeholder="Full Name"
                                      variant="outlined"
                                      value={values.fullName.toUpperCase()}
                                      error={
                                        touched.fullName &&
                                        Boolean(errors.fullName)
                                      }
                                      helperText={
                                        touched.fullName &&
                                        errors.fullName?.toString()
                                      }
                                      InputLabelProps={{
                                        sx: {
                                          color: "#6B7280",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          "&.MuiFormLabel-filled": {
                                            color: "#111827",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            fontFamily: "inherit",
                                          },
                                        },
                                      }}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      inputProps={{
                                        sx: {
                                          "&::label": {
                                            fill: "#111827",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                          },
                                          color: "#121923",
                                          fontSize: "14px",
                                          "&::placeholder": {
                                            color: "#6B7280",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            opacity: 0.6,
                                          },
                                        },
                                        maxLength: 10,
                                      }}
                                      // disabled={disablePan}
                                    />
                                  </div>
                                  <div>
                                    <div className={PanStyles.labeltext}>
                                      PAN{" "}
                                    </div>
                                    <TextField
                                      autoComplete="off"
                                      sx={{
                                        fieldset: {
                                          borderColor: "#E5E7EB",
                                          borderRadius: "100px",
                                        },
                                      }}
                                      className={PanStyles.textfeild}
                                      id="outlined-basic"
                                      // label="PAN"
                                      name="pannumber"
                                      placeholder="PAN"
                                      variant="outlined"
                                      value={values.pannumber.toUpperCase()}
                                      error={
                                        touched.pannumber &&
                                        Boolean(errors.pannumber)
                                      }
                                      helperText={
                                        touched.pannumber &&
                                        errors.pannumber?.toString()
                                      }
                                      InputLabelProps={{
                                        sx: {
                                          color: "#6B7280",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          "&.MuiFormLabel-filled": {
                                            color: "#111827",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            fontFamily: "inherit",
                                          },
                                        },
                                      }}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      inputProps={{
                                        sx: {
                                          "&::label": {
                                            fill: "#111827",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                          },
                                          color: "#121923",
                                          fontSize: "14px",
                                          "&::placeholder": {
                                            color: "#6B7280",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            opacity: 0.6,
                                          },
                                        },
                                        maxLength: 10,
                                      }}
                                      // disabled={disablePan}
                                    />
                                  </div>

                                  {/* <div style={{ marginTop: "-10px" }}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker"]}>
                                  <DatePicker
                                    className={PanStyles.datePicker}
                                    components={{ OpenPickerIcon: DateIcon }}
                                    minDate={maxDate}
                                    maxDate={eighteenYearsAgo}
                                    format="DD-MM-YYYY"
                                    renderYear={renderYear}
                                    views={["year", "month", "day"]}
                                    label="DOB as per PAN"
                                    InputLabelProps={{
                                      sx: {
                                        color: "grey", // Default label color
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827", // Label color when a value is selected
                                          fontFamily: "inherit",
                                        },
                                      },
                                    }}
                                    name="dateofBirth"
                                    value={values.dateofBirth}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        color: "#6B7280", // Default label color for date picker
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.Mui-focused": {
                                          color: "#111827", // Focused label color
                                        },
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          fontFamily: "inherit",
                                        },
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                    }}
                                    onChange={(date) => {
                                      handleChange({
                                        target: {
                                          name: "dateofBirth",
                                          value: date,
                                        },
                                      });
                                      //  console.log("date", date);
                                    }}
                                    onBlur={handleBlur}
                                    error={
                                      touched.dateofBirth &&
                                      Boolean(errors.dateofBirth)
                                    }
                                    helperText={
                                      touched.dateofBirth && errors.dateofBirth
                                    }
                                    renderInput={(params: any) => (
                                      <TextField {...params} />
                                    )}
                                    {...(DatePicker as any)}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                              <FormHelperText
                                style={{
                                  color: "#d32f2f",
                                  textAlign: "center",
                                }}
                              >
                                {dobError}
                              </FormHelperText>
                            </div> */}
                                </div>

                                <div className={PanStyles.divider}></div>

                                <div className={PanStyles.emailDetails}>
                                  <div className={PanStyles.feilditems}>
                                    <div
                                      style={{
                                        position: "relative",
                                        // width: !isGoogleVerified ? "" : "100%",
                                      }}
                                      className={PanStyles.feilditemsDiv}
                                    >
                                      <TextField
                                        autoComplete="off"
                                        sx={{
                                          fieldset: {
                                            borderColor: "#E5E7EB",
                                            borderRadius: "100px",
                                          },
                                        }}
                                        inputProps={{
                                          maxLength: 75,
                                          onKeyDown: (e) =>
                                            e.key === " " && e.preventDefault(), // Prevents typing space
                                          onInput: (e) =>
                                            (e.currentTarget.value =
                                              e.currentTarget.value.replace(
                                                /\s/g,
                                                "",
                                              )),
                                          sx: {
                                            "&::label": {
                                              fill: "#111827",
                                              fontWeight: 400,
                                              fontSize: "14px",
                                            },
                                            color: "#121923",
                                            fontSize: "14px",
                                            "&::placeholder": {
                                              color: "#6B7280",
                                              fontWeight: 400,
                                              fontSize: "14px",
                                              opacity: 0.6,
                                            },
                                          },
                                        }}
                                        className={PanStyles.textfieldEmail}
                                        name="email"
                                        value={values.email}
                                        error={
                                          touched.email && Boolean(errors.email)
                                        }
                                        // helperText={
                                        //   touched.email && errors.email?.toString()
                                        // }
                                        onChange={(event: any) => {
                                          if (
                                            event.target.value === emailGoogle
                                          ) {
                                            setIsGoogleVerified(true);
                                            setFieldValue("emailotp", "123456");
                                          } else {
                                            setIsGoogleVerified(false);
                                            setFieldValue("emailotp", "");
                                          }

                                          handleChange(event);
                                        }}
                                        onBlur={handleBlur}
                                        id="outlined-basic"
                                        label=""
                                        placeholder="Email"
                                        variant="outlined"
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              {values.email && (
                                                <>
                                                  {!isGoogleVerified && (
                                                    <>
                                                      {emailGoogle !==
                                                        values.email && (
                                                        <>
                                                          {emailtyped !==
                                                          values.email ? (
                                                            <Button
                                                              disableElevation
                                                              disableFocusRipple
                                                              disableTouchRipple
                                                              size="small"
                                                              sx={{
                                                                width: "73px",
                                                                height:
                                                                  "max-content",
                                                                background:
                                                                  "#3263E5",
                                                                color: "#fff",
                                                                fontSize:
                                                                  "12px",
                                                                fontWeight: 400,
                                                                padding: "4px",
                                                                "&:hover": {
                                                                  background:
                                                                    "#3263E5",
                                                                },
                                                              }}
                                                              onClick={() => {
                                                                if (
                                                                  !getloading
                                                                ) {
                                                                  sendEmailAddress(
                                                                    values.email,
                                                                    values.fullName,
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              {getloading ? (
                                                                <CircularProgress
                                                                  style={{
                                                                    color:
                                                                      "inherit",
                                                                    width:
                                                                      "20px",
                                                                    height:
                                                                      "20px",
                                                                  }}
                                                                />
                                                              ) : (
                                                                "Get OTP"
                                                              )}
                                                            </Button>
                                                          ) : (
                                                            <Button
                                                              disableElevation
                                                              disableFocusRipple
                                                              disableTouchRipple
                                                              size="small"
                                                              disabled={
                                                                isButtonDisabled
                                                              }
                                                              sx={{
                                                                width: "73px",
                                                                height:
                                                                  "max-content",
                                                                background:
                                                                  "#3263E5",
                                                                color: "#fff",
                                                                fontSize:
                                                                  "12px",
                                                                fontWeight: 400,
                                                                padding: "4px",
                                                                "&:hover": {
                                                                  background:
                                                                    "#3263E5",
                                                                },
                                                                "&.Mui-disabled":
                                                                  {
                                                                    background:
                                                                      "#3263E5 !important",
                                                                    color:
                                                                      "#fff",
                                                                    opacity: 0.5,
                                                                  },
                                                              }}
                                                              onClick={() => {
                                                                setFieldValue(
                                                                  "mobileotp",
                                                                  "",
                                                                );
                                                                handleResendOTP(
                                                                  values,
                                                                );
                                                              }}
                                                            >
                                                              Resend
                                                            </Button>
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                      <FormHelperText
                                        style={{
                                          color: "#d32f2f",
                                          height: "10px",
                                          marginTop: "3px",
                                          textAlign: "center",
                                          position: "absolute",
                                          width: "100%",
                                        }}
                                      >
                                        {touched.email &&
                                          errors.email?.toString()}
                                      </FormHelperText>
                                    </div>
                                    {/* {!isGoogleVerified && email === values.email && ( */}
                                    <>
                                      <div className={PanStyles.ortext}>or</div>
                                      {!isMobile && (
                                        <div className={PanStyles.google}>
                                          <ContinueWithGoogleNew
                                            handleCallBack={callBackMessage}
                                            handleCallBackSuccess={(
                                              googleData: any,
                                            ) => {
                                              setFieldValue(
                                                "email",
                                                googleData?.email,
                                              );
                                              setOtpSent(false);
                                              setFieldValue(
                                                "emailotp",
                                                "123456",
                                              );
                                              handleCallBackSuccess(googleData);
                                            }}
                                          />
                                        </div>
                                      )}
                                    </>
                                    {/* )} */}
                                  </div>
                                  {otpSent && (
                                    <>
                                      <div
                                        className={PanStyles.otpfeilditems}
                                        style={{ position: "relative" }}
                                      >
                                        <TextField
                                          autoComplete="off"
                                          autoFocus
                                          label=""
                                          InputLabelProps={{ shrink: false }}
                                          placeholder=""
                                          // placeholder="••••••"
                                          className={PanStyles.textfieldotp}
                                          variant="outlined"
                                          value={values.emailotp}
                                          type="numeric"
                                          onChange={(event) => {
                                            const updatedValue =
                                              event.target.value;
                                            handleChangeField(
                                              "emailotp",
                                              updatedValue,
                                              setFieldValue,
                                              values,
                                            );
                                          }}
                                          inputProps={{
                                            sx: {
                                              "&::placeholder": {
                                                paddingLeft: "-20px",

                                                fill: "var(--Black-Black-500, #6B7280)",
                                                fontWeight: 600,
                                                fontSize: "2.19rem",
                                                background: "transparent",
                                                height: "29px",
                                                letterSpacing: {
                                                  xs: "23px",
                                                  sm: "19px",
                                                },
                                              },
                                              // borderLeft: "1px solid #E5E7EB",
                                              // height: "30px",
                                              paddingLeft: "-20px",

                                              fontWeight: 500,
                                              letterSpacing: {
                                                xs: "29.5px",
                                                sm: "24.5px",
                                              },
                                              background: "transparent",
                                            },
                                            maxLength: 6,
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                          }}
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment
                                                position="start"
                                                style={{
                                                  // borderRight: "1px solid #E5E7EB",
                                                  // height: "22px",
                                                  paddingRight: "10px",
                                                  paddingLeft: "5px",
                                                }}
                                              >
                                                <img src={otpIcon} />
                                              </InputAdornment>
                                            ),
                                          }}
                                          onKeyPress={(event) => {
                                            const keyCode =
                                              event.keyCode || event.which;
                                            const keyValue =
                                              String.fromCharCode(keyCode);
                                            const isValidKey = /^\d+$/.test(
                                              keyValue,
                                            );

                                            if (!isValidKey) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                        <FormHelperText
                                          style={{
                                            color: "#d32f2f",
                                            height: "10px",
                                            marginTop: "3px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {touched.emailotp &&
                                            errors.emailotp?.toString()}
                                        </FormHelperText>
                                        {values.emailotp.length === 0 && (
                                          <div
                                            className={
                                              PanStyles.placeholderstyling
                                            }
                                          >
                                            {dots.map((a: any, index: any) => (
                                              <div
                                                className={PanStyles.dot}
                                                style={{
                                                  opacity:
                                                    values.emailotp.length +
                                                      1 >=
                                                    index + 1
                                                      ? "0.4"
                                                      : "1",
                                                }}
                                              ></div>
                                            ))}
                                          </div>
                                        )}
                                        {values.emailotp.length > 0 && (
                                          <div
                                            className={
                                              PanStyles.placeholderstyling
                                            }
                                          >
                                            {dots.map((a: any, index: any) => (
                                              <div
                                                className={PanStyles.dot}
                                                style={{
                                                  opacity:
                                                    values.emailotp.length +
                                                      1 >=
                                                    index + 1
                                                      ? "0.4"
                                                      : "1",
                                                  visibility:
                                                    values.emailotp.length >=
                                                    index + 1
                                                      ? "hidden"
                                                      : "visible",
                                                }}
                                              ></div>
                                            ))}
                                          </div>
                                        )}
                                      </div>

                                      {isButtonDisabled ? (
                                        <div
                                          className={PanStyles.resendSection}
                                        >
                                          <p className={PanStyles.clickhere}>
                                            Resend OTP in{" "}
                                            <span style={{ color: "#3263E5" }}>
                                              {countdown}
                                            </span>{" "}
                                            Seconds
                                          </p>
                                        </div>
                                      ) : (
                                        <div
                                          className={PanStyles.resendSection}
                                        ></div>
                                      )}
                                    </>
                                  )}

                                  <div className={PanStyles.mobilebottom}>
                                    <div className={PanStyles.ordiv}>
                                      <div className={PanStyles.divid}></div>
                                      <div className={PanStyles.ortextmob}>
                                        or
                                      </div>
                                      <div className={PanStyles.divid}></div>
                                    </div>
                                    {isMobile && (
                                      <div className={PanStyles.googleMobile}>
                                        <ContinueWithGoogle
                                          handleCallBack={callBackMessage}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className={PanStyles.buttonSection}>
                                  {values.emailotp !== "" &&
                                  values.pannumber?.length > 9 &&
                                  values.email !== "" ? (
                                    <LoadingButton
                                      type="submit"
                                      variant="contained"
                                      loading={loading}
                                      id="panVerificationContinueButton"
                                      className={PanStyles.button}
                                      onClick={() => {
                                        handleSubmit();
                                      }}
                                    >
                                      Continue
                                    </LoadingButton>
                                  ) : (
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      disabled
                                      className={PanStyles.button}
                                    >
                                      Continue
                                    </Button>
                                  )}
                                </div>
                                {/* <div className={PanStyles.startovernewsection}>
                            The PAN must belong to you. If not,{" "}
                            <span
                              onClick={handleStartOver}
                              style={{
                                fontWeight: 500,
                                cursor: "pointer",
                                color: "#111827",
                              }}
                            >
                              Start&nbsp;Over
                            </span>
                          </div> */}
                                <div className={PanStyles.startovernewsection}>
                                  I authorise FIRSTOCK to fetch my KYC
                                  information from the CKYC registry using my
                                  PAN
                                </div>

                                {/* <div className={PanStyles.bottomContentContainer}>
                            <p className={PanStyles.bottomContent}>
                              - Your account name would be taken as per the name
                              registered on the Income Tax Database
                            </p>
                            <p className={PanStyles.bottomContent}>
                              - To open an account online, ensure your mobile
                              number is linked to your Aadhaar; otherwise, you
                              will need to{" "}
                              <a
                                href="https://firstock-common.s3.ap-south-1.amazonaws.com/forms/Individual+Application+.pdf"
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                proceed offline
                              </a>
                              . We do not collect or store your Aadhaar number
                            </p>
                            <p className={PanStyles.bottomContent}>
                              - For online account opening, use Digi locker for
                              identity verification if you are not KRA verified,
                              and digitally sign the application.
                            </p>
                            <p className={PanStyles.bottomContent}>
                              - For HUF, Corporate, Partnership, or NRI
                              accounts,{" "}
                              <a
                                href="https://firstock-common.s3.ap-south-1.amazonaws.com/forms/Individual+Application+.pdf"
                                target="_blank"
                                style={{
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                offline forms
                              </a>{" "}
                              must be completed.
                            </p>
                          </div> */}

                                <ErrorSnackBar message={rejectMessage} />
                                <SnackBar message={message} />
                              </form>
                            </>
                          );
                        }}
                      </Formik>
                    </>
                  ) : (
                    <>
                      <Backdrop
                        sx={{
                          color: "#fff",
                          zIndex: (theme) => theme.zIndex.drawer + 1,
                        }}
                        open={open}
                      >
                        <CircularProgress color="inherit" />
                      </Backdrop>
                    </>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className={PanStyles.fetchWrapper}>
              <KRAScreen aadhaarData={KraData} />
              <div className={PanStyles.fetchButtons}>
                <Button
                  id="continue2"
                  variant="outlined"
                  className={PanStyles.fetchUpdate}
                  onClick={handleDigilocker}
                  sx={{ height: "50px", color: "#1F2937" }}
                >
                  Update as on Aadhaar
                </Button>
                <Button
                  id="continue1"
                  variant="contained"
                  className={PanStyles.fetchContinue}
                  onClick={CompleteAadhaarStage}
                  sx={{ height: "50px" }}
                >
                  Continue
                </Button>
              </div>
            </div>
          )}
        </div>
      </>
    </>
  );
}
